var render = function render(){var _vm=this,_c=_vm._self._c;return _c('near-by-company')
}
var staticRenderFns = []

export { render, staticRenderFns }